import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import "./styles.css";
import ourLogo from "../../../assets/images/logo-new.jpg";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import nfsscLogo from "../../../assets/images/nfssclogo.png";
const OurTeamSection = () => {
  const [getAllTeamsData, setGetAllTeamsData] = useState([]);
  const [teamDetails, setTeamDetails] = useState({});
  const handleGetTeamsData = async () => {
    try {
      const getTeams = await axios.get(
        "https://backend.nileshdawande.in/teams/all-team"
      );
      if (getTeams?.data?.isDataFound === true) {
        setGetAllTeamsData(getTeams?.data?.data);
      }
    } catch (error) {
      if (error.response.status === 400) {
        const message_400 = error?.response?.data?.message;
        toast.error(message_400);
      } else if (error.response.status === 401) {
        const message_401 = error?.response?.data?.message;
        toast.error(message_401);
      } else if (error.response.status === 404) {
        const message_404 = error?.response?.data?.message;
        console.log("message_404", message_404);
        toast.error(message_404);
      } else if (error.response.status === 500) {
        const message_500 = error?.response?.data?.message;
        toast.error(message_500);
      } else {
        toast.error("something went wrong");
      }
    }
  };

  console.log("teamDetails", teamDetails);
  useEffect(() => {
    handleGetTeamsData();
  }, []);

  return (
    <Layout>
      <div className="about-container">
        <div className="container py-3">
          <div className="row">
            <div className="col-12">
              {" "}
              <h1 className="about-title">Our Team</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card my-3 mx-auto" style={{ maxWidth: 450 }}>
                <div className="row g-0">
                  <div className="col-12">
                    <div className="list-main-box text-center">
                      <img
                        src={nfsscLogo}
                        className="img-fluid my-2 rounded"
                        alt="..."
                      />
                      {getAllTeamsData?.map((value, key) => {
                        return (
                          <div className="card custeamCard">
                            <img
                              className="card-img-top teamImg"
                              src={`https://backend.nileshdawande.in/images/${value?.Pic}`}
                              alt=""
                            />
                            <div className="card-body custeamInfo">
                              <div className="team-name">{value?.Name}</div>
                              <h6 className="team-degignation-name">
                                {value?.Designation}
                              </h6>
                              <div className="social-links">
                                <a
                                  href={value?.FacebookLink}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i className="fab fa-facebook-f"></i>
                                </a>
                                <a
                                  href={value?.LinkeDinLink}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i className="fab fa-linkedin-in"></i>
                                </a>
                                <a
                                  href={value?.InstagramLink}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i className="fab fa-instagram"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                More Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="card mb-3">
                <div className="row g-0 align-items-center">
                  <div className="details-img col-md-4">
                    <img
                      src={`https://backend.nileshdawande.in/images/${teamDetails?.Pic}`}
                      // className="img-fluid"
                      alt="..."
                    />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body team-details">
                      <h5 className="card-title text-dark">
                        {teamDetails?.Designation}
                      </h5>
                      <div className="flex-container">
                        <div>Full Name :</div>
                        <div>{teamDetails?.Name}</div>
                      </div>
                      {/* <div className="flex-container">
                        <div>Mobile Number:</div>
                        <div>{teamDetails?.Designation}</div>
                      </div> */}
                      <div className="flex-container">
                        <div>Facebook Link :</div>
                        <div>
                          <a href={teamDetails?.FacebookLink} target="blank">
                            {teamDetails?.FacebookLink}
                          </a>
                        </div>
                      </div>
                      <div className="flex-container">
                        <div>Instagram Link :</div>
                        <div>
                          <a href={teamDetails?.InstagramLink} target="blank">
                            {teamDetails?.InstagramLink}
                          </a>
                        </div>
                      </div>
                      <div className="flex-container">
                        <div>LinkeDin Link :</div>
                        <div>
                          {" "}
                          <a href={teamDetails?.LinkeDinLink} target="blank">
                            {teamDetails?.LinkeDinLink}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" />
    </Layout>
  );
};
export default OurTeamSection;
